import React, { useContext } from "react";
import { Context } from "../../../Context";
import { ConfigurationDomainsView } from "../../views";
import { DomainService, LocalStorageService } from "../../../services/index";
import { ValidateInputPure } from "../../pures";
import { ConfigurationDomainValidator } from "../../../validators";
import { useTranslation } from "react-i18next";

class ConfigurationDomainsAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skip: 0,
      take: 6,
      showPagination: "",
      name: "",
      dataItem: {},

      domains: [],
      visible: false,
      idCounter: 0,

      userInEdit: undefined,
      userInRemove: null,

      errorCurrentDomain: false,

      messageErrorCurrentDomain: "",
      disableUserButton: true,

      showNotification: false,
      message: "Ocurrio un error",

      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorSingleDomain: false,
      showErrorRequesting: false,
      showErrorDomainSigner: false,
      showErrorDomainSignerUpdate: false,
      buttonType: 0,
      loading: false,

      visibleDialogDeleteRequest: false,
      saveError: false,
      loadingComponent: false,
      inputValidate: false,
    };

    this.toggleDialog = this.toggleDialog.bind(this);
    this.onDeleteData = this.onCancelData.bind(this);
  }

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      top: 150,
      right: 30,
      position: "fixed",
    },
  };

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  domainService = new DomainService(this.url);

  validator = ConfigurationDomainValidator(this.props.t);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let requests = await this.domainService.getDomains(this.token);
    if (requests != null) {
      this.setState({
        domains: requests,
        loading: false,
      });
      this.onChangeFooterInfoPagination();
    } else {
      this.setState({
        domains: "",
        loading: false,
      });
    }
  }

  /**
   * @author Alan Aguilar
   * @date 19-11-2020
   * @description Change the rendering of a custom footer in the grid
   * @memberof ConfigurationAdministrateAction
   */
  onChangeFooterInfoPagination = () => {
    let paginationInfoExist = document.querySelector(
      "#infoPaginationAdministrate"
    );
    if (paginationInfoExist) {
      paginationInfoExist.remove();
      this.setState({ showPagination: false });
    }

    let { domains, take, skip } = this.state;

    let totalItemsInTable = domains.length;
    if (domains.length !== 0) {
      this.setState({ showPagination: { info: false } }, () => {
        let currentPage = Math.floor(skip / take) + 1;
        let totalPages = Math.ceil((totalItemsInTable || 0) / take);

        let firstItemInPage = skip + 1;
        let lastItemInPage = 0;
        if (currentPage === totalPages) {
          lastItemInPage = totalItemsInTable;
        } else {
          lastItemInPage = skip + take;
        }

        let footerPagination = document.querySelector("div[role='navigation']");
        if (footerPagination) {
          let element = document.createElement("div");
          element.id = "infoPaginationAdministrate";
          element.innerHTML = `<span>${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Dominios</span> <span style="margin-left: 30px;">${currentPage}/${totalPages}</span>`;
          element.className = "k-pager-info k-label";
          footerPagination.appendChild(element);
        }
      });
    } else {
      this.setState({ showPagination: false });
    }
  };

  /**
   * @author Alan Aguilar
   * @description Method to close the alert of the form
   * @memberof ConfigurationDomainsAction
   */
  onCloseOpenModal = () => {
    this.setState({ showNotification: false });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the notification and then close
   * @memberof ConfigurationDomainsAction
   */
  handleMessage = (message) => {
    this.setState(
      {
        showNotification: true,
        message,
      },
      () => {
        setTimeout(() => {
          this.onCloseOpenModal();
        }, 8000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof ConfigurationDomainsAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof ConfigurationDomainsAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to show or hide dialog
   * @memberof ConfigurationDomainsAction
   */
  toggleDialog() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Delete
   * @param {Object} dataItem
   * @memberof ConfigurationDomainsAction
   */
  toggleDialogDeleteDomain = (dataItem) => {
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
      userInRemove: dataItem,
    });
    if (this.state.visibleDialogDeleteRequest === false)
      this.setState({ errorCommentsDelete: false });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof SignatureRequestAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  toggleErrorDomainSigner = (value) => {
    this.setState(
      {
        showErrorDomainSigner: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorDomainSigner: false });
        }, 7000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to hide the error dialog update domain
   * @memberof ConfigurationDomainsAction
   */
  toggleErrorDomainSignerUpdate = (value) => {
    this.setState(
      {
        showErrorDomainSignerUpdate: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorDomainSignerUpdate: false });
        }, 7000);
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Method to hide the dialog
   * @memberof ConfigurationDomainsAction
   */
  onCancelData() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Lucia Alvarado
   * @description Change page in paginnation of table
   * @param {Object} dataItem
   * @memberof ConfigurationDomainsAction
   */
  onPageChange = (event) => {
    this.setState(
      {
        skip: event.page.skip,
        take: event.page.take,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Insert new user in the grid
   * @memberof ConfigurationDomainsAction
   */
  insert = () => {
    this.setState({
      userInEdit: {},
      buttonType: 0,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Add a domain
   * @param {Object} dataItem
   * @memberof ConfigurationDomainsAction
   */
  newDomain(dataItem) {
    const id = ++this.idCounter;
    const newDomain = {
      id: id,
      name: "",
    };
    return Object.assign(newDomain, dataItem);
  }

  /**
   * @author Lucia Alvarado
   * @description Save data of dialog
   * @memberof ConfigurationDomainsAction
   */
  save = async () => {
    let { name } = this.state.userInEdit;
    let domainValid = this.validator.domainValidator(name);
    if ((name === null && name === "") || domainValid !== "") {
      this.setState({
        errorCurrentDomain: true,
        messageErrorCurrentDomain: this.props.t(
          "configuration.domain.action.messageErrorCurrentDomain"
        ),
      });
      return false;
    }

    const dataItem = this.state.userInEdit;
    const users = this.state.users.slice();
    const isNewUser = dataItem.id === undefined;

    if (isNewUser) {
      users.unshift(this.newDomain(dataItem));
    } else {
      const index = users.findIndex((p) => p.name === dataItem.name);
      users.splice(index, 1, dataItem);
    }

    this.setState(
      {
        domains: users,
        userInEdit: undefined,
        errorNotSigners: false,
        errorCurrentDomain: false,
        messageErrorCurrentDomain: "",
        inputValidate: false,
      },
      () => {
        this.onChangeFooterInfoPagination();
      }
    );
  };

  /**
   * @author Lucia Alvarado
   * @description Edit a domain
   * @param {Object} dataItem
   * @memberof ConfigurationDomainsAction
   */
  edit = (dataItem) => {
    this.setState({
      buttonType: 1,
      userInEdit: this.cloneDomain(dataItem),
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Duplicate data domain for the grid
   * @param {Object} user
   * @memberof ConfigurationDomainsAction
   */
  cloneDomain(user) {
    return Object.assign({}, user);
  }

  /**
   * @author Lucia Alvarado
   * @description Remove a domain of grid
   * @param {Object} dataItem
   * @memberof ConfigurationDomainsAction
   */
  remove = async (dataItem) => {
    this.setState({
      userInRemove: dataItem,
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to clear and hide dialog
   * @memberof ConfigurationDomainsAction
   */
  cancel = () => {
    this.setState({
      userInEdit: undefined,
      disableUserButton: true,
      errorCurrentDomain: false,
      messageErrorCurrentDomain: "",
      // messageErrorCurrentName: '',
      // messageErrorCurrentLastName: '',
      // errorUserType: false,
      inputValidate: false,
    });
  };

  cancelError = () => {
    this.setState({
      saveError: false,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to save form of the dialog
   * @param {Event} event
   * @memberof ConfigurationDomainsAction
   */
  handleSubmit = (event) => {
    event.preventDefault();
    this.save();
    this.setState({ disableUserButton: true });
  };

  /**
   * @author Lucia Alvarado
   * @description Method to change the data of form dialog
   * @param {Event} event
   * @memberof ConfigurationDomainsAction
   */
  onDialogInputChange = (event) => {
    let target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.props ? target.props.name : target.name;

    const edited = this.state.userInEdit;
    edited[name] = value;

    this.setState({
      userInEdit: edited,
    });

    // let domainValid = "";
    // // if (name === "name") domainValid = this.validator.domainValidator(value);

    // if (this.state.userInEdit.name !== null && domainValid === "") {
    //   this.setState({
    //     errorCurrentDomain: false,
    //     messageErrorCurrentDomain: "",
    //     disableUserButton: false,
    //   });
    // } else {
    //   this.setState({
    //     errorCurrentDomain: true,
    //     messageErrorCurrentDomain: this.props.t(
    //       "configuration.domain.action.messageErrorCurrentDomain"
    //     ),
    //     disableUserButton: true,
    //   });
    // }
  };

  /**
   * @author Leonel Contreras
   * @description Close/Open the modal
   */
  onCloseOpenModal = () =>
    this.setState({ showNotification: !this.state.showNotification });

  /**
   * @author Leonel Contreras
   * @description Close the modal after some time
   */
  handleMessage = () => {
    setTimeout(() => {
      this.onCloseOpenModal();
    }, 15000);
  };

  /**
   * @author Lucia Alvarado
   * @description Method to move scroll
   * @memberof ConfigurationDomainsAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  /**
   * @author Lucia Alvarado
   * @description Delete collaborator
   * @param {Event} event
   * @memberof ConfigurationDomainsAction
   */
  deleteDomain = async () => {
    let messageError = this.props.t("configuration.domain.action.delete-domain")
    try {
      this.setState({ visibleDialogDeleteRequest: false });
      this.toggleLoadingRequesting(true);
      let response = await this.domainService.deleteDomain(
        this.state.userInRemove.id,
        this.state.userInRemove.clientId,
        this.token
      );
      if (response.statusCode === 200) {
        let requests = await this.domainService.getDomains(this.token);

        this.setState(
          {
            domains: requests,
          },
          () => {
            this.onChangeFooterInfoPagination();
          }
        );
      } else if (response.statusCode === -1) {
       this.toggleLoadingRequesting(false);
       this.toggleErrorRequesting(true);
        return false;
      } else if (response.statusCode === -3) {
        this.setState({
          message: this.props.t(
            "configuration.domain.action.domainSignerDeleteError"
          ),
        });
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return false;
      } else if (response.statusCode === -4) {
        this.setState({
          showErrorRequesting: true,
          message: this.props.t(
            "configuration.domain.action.domainDeleteError"
          ),
        });
      }else{
        this.setState({
          message: messageError
        })
        this.toggleLoadingRequesting(false);
         this.toggleErrorRequesting(true);  
      }
      this.toggleLoadingRequesting(false);
      this.toggleCompletedRequesting(true);
      return true;
    } catch (error) {
      console.log(error)
      this.setState({
        message: messageError
      })
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      return false;
    }
  };


  /**
  * @author Edgar Escobedo
  * @description Create new domain
  * @param {Event} event
  * @memberof ConfigurationAdministrateView
  */
  createNewDomain = async(data, backGrid) => {
    this.toggleLoadingRequesting(true)
    let messageError = this.props.t("configuration.domain.action.general.error")
    
    let { name, description } = data
    try {
      let domainValid = this.validator.domainValidator(name);
      if(domainValid !== ""){
        this.setState({message: this.props.t("configuration.domain.action.messageErrorCurrentDomain")})
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      }
  
      let domain = await this.domainService.createDomain(
        name,
        description,
        this.token
      );

      if (domain.statusCode === 200) {
        let requests = await this.domainService.getDomains(this.token);
        this.setState({
          domains: requests
        });
        this.toggleLoadingRequesting(false);
        this.toggleCompletedRequesting(true);
        setTimeout(() => {
          backGrid()
        },[4000])
        return;
      } else if (domain.statusCode === -1) {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
      } else if (domain.statusCode === -2) {
        this.setState({
          message: this.props.t("configuration.domain.action.domainExists"),
        });
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      }else{
        this.setState({message: messageError})
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true);
        return;
      }
    } catch (error) {
      this.setState({message: messageError})
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(true);
    }
  }

  handleEditDomain = async(data, backGrid) => {
    this.toggleLoadingRequesting(true)
    let messageError = this.props.t("configuration.domain.action.general.error.edit")
    let { id, clientId, name, description } = data

    try {
      let domainValid = this.validator.domainValidator(name);
      if(domainValid !== ""){
        this.setState({message: this.props.t("configuration.domain.action.messageErrorCurrentDomain")})
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      }

      let domainUpdated = await this.domainService.updateDomain(
        id,
        clientId,
        name,
        description,
        this.token
      );
  
      if (domainUpdated.statusCode === 200) {
        let requests = await this.domainService.getDomains(this.token);
        this.setState({
          domains: requests
        });
    
        this.toggleLoadingRequesting(false);
        this.toggleCompletedRequesting(true);
        setTimeout(() => {
          backGrid()
        },[4000])
        return;

      }else if (domainUpdated.statusCode === -1) {
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      } else if (domainUpdated.statusCode === -2) {
        this.setState({
          message: this.props.t("configuration.domain.action.updateDomainError"),
        });
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      }else if (domainUpdated.statusCode === -3) {
        this.setState({
          message: this.props.t("configuration.domain.action.domainSignerUpdateError"),
        });
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return false;
      }else{
        this.setState({message:messageError})
        this.toggleLoadingRequesting(false);
        this.toggleErrorRequesting(true);
        return;
      }
    } catch (error) {
      this.setState({message:messageError})
      this.toggleLoadingRequesting(false);
      this.toggleErrorRequesting(true);
      return;
    }
  }

  render() {
    return (
      <ConfigurationDomainsView
        {...this.state}
        regex={this.regex}
        validator={this.validator}
        validateInput={ValidateInputPure}
        onSubmit={this.onSubmit}
        toggleDialog={this.toggleDialog}
        onCancelData={this.onCancelData}
        onPageChange={this.onPageChange}
        insert={this.insert}
        save={this.save}
        edit={this.edit}
        newDomain={this.newDomain}
        remove={this.remove}
        cancel={this.cancel}
        handleSubmit={this.handleSubmit}
        onDialogInputChange={this.onDialogInputChange}
        cloneDomain={this.cloneDomain}
        notification={this.notification}
        onCloseOpenModal={this.onCloseOpenModal}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        saveError={this.state.saveError}
        cancelError={this.cancelError}
        toggleDialogDeleteDomain={this.toggleDialogDeleteDomain}
        deleteDomain={this.deleteDomain}
        loadingComponent={this.state.loadingComponent}
        inputValidate={this.state.inputValidate}
        onChangeFooterInfoPagination={this.onChangeFooterInfoPagination}
        scrollWindow={this.scrollWindow}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleErrorDomainSigner={this.toggleErrorDomainSigner}
        toggleErrorDomainSignerUpdate={this.toggleErrorDomainSignerUpdate}
        createNewDomain = {this.createNewDomain}
        handleEditDomain = {this.handleEditDomain}
      />
    );
  }
}

function ConfigurationDomainsActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <ConfigurationDomainsAction {...props} t={t} setShowError={setShowError} />
  );
}

export { ConfigurationDomainsActionContainer as default };
